<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date'
import { TimesheetOperationTypeInts } from '@/constants/disputes/TimesheetOperationType'
import timesheetMixin from '@/mixins/timesheetMixin'

export default {
  name: 'DisputesTableBreaks',
  mixins: [baseMixin, timesheetMixin],
  props: {
    dispute: {
      type: Object,
      required: true,
    },
  },
  computed: {
    candidateHasSubmitted() {
      return this.candidateHasSubmittedTimesheet(this.dispute.bookingStatus)
    },
    clientHasSubmitted() {
      return this.clientHasSubmittedTimesheet(this.dispute.bookingStatus)
    },
    hasCandidateModifiedTimesheet() {
      if (!this.candidateHasSubmitted) return false
      return (
        this.dispute.candidateTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    hasClientModifiedTimesheet() {
      if (!this.clientHasSubmitted) return false
      return (
        this.dispute.clientTimesheet.operationType ===
        TimesheetOperationTypeInts.MODIFY
      )
    },
    getLatestAndPreviousBreakMinutes() {
      const candidateSubmittedDate = this.hasCandidateModifiedTimesheet
        ? this.dispute.candidateTimesheet?.submittedDateUtc
        : null
      const clientSubmittedDate = this.hasClientModifiedTimesheet
        ? this.dispute.clientTimesheet?.submittedDateUtc
        : null

      let latestBreaks = this.dispute.breakMinutes

      let previousBreaks = null

      if (candidateSubmittedDate && clientSubmittedDate) {
        const candidateTimesheetIsLatest = dayjs(
          candidateSubmittedDate
        ).isAfter(dayjs(clientSubmittedDate))

        latestBreaks = candidateTimesheetIsLatest
          ? this.dispute.candidateTimesheet.breakMinutes
          : this.dispute.clientTimesheet.breakMinutes

        previousBreaks = !candidateTimesheetIsLatest
          ? this.dispute.candidateTimesheet.breakMinutes
          : this.dispute.clientTimesheet.breakMinutes
      } else if (candidateSubmittedDate) {
        latestBreaks = this.dispute.candidateTimesheet.breakMinutes
        previousBreaks = this.dispute.breakMinutes
      } else if (clientSubmittedDate) {
        latestBreaks = this.dispute.clientTimesheet.breakMinutes
        previousBreaks = this.dispute.breakMinutes
      }

      return {
        latest: this.compileBreaksString(latestBreaks),
        previous: previousBreaks
          ? this.compileBreaksString(previousBreaks)
          : null,
      }
    },
    showPreviousBreaks() {
      return !!this.getLatestAndPreviousBreakMinutes.previous
    },
    strikeThroughPreviousBreaks() {
      if (!this.showPreviousBreaks) return false
      return (
        this.getLatestAndPreviousBreakMinutes.previous !==
        this.getLatestAndPreviousBreakMinutes.latest
      )
    },
  },
  methods: {
    compileBreaksString(breakMinutes) {
      return `${breakMinutes} mins`
    },
  },
}
</script>

<template>
  <div>
    <div>
      {{ getLatestAndPreviousBreakMinutes.latest }}
    </div>
    <div
      v-if="showPreviousBreaks"
      :class="[
        strikeThroughPreviousBreaks ? 'text-decoration-line-through' : '',
        'text-caption opacity-5',
      ]"
    >
      {{ getLatestAndPreviousBreakMinutes.previous }}
    </div>
  </div>
</template>
